export const SEARCH_QUERY_ALLOWED_CHARS_REGEX = /^[a-z0-9]+$/i;
